import React, { FC } from 'react';

import { TextInput } from '@gravity-ui/uikit';

import styles from './AliceAgentAppEditPage.module.scss';

export type Locale = 'ru' | 'en';
export const LOCALES: readonly Locale[] = ['ru', 'en'] as const;

export type LocalizedString = Record<Locale, string>;

export const fromManifestMap = (map: Record<string, string> | undefined): LocalizedString => ({
    ru: map?.ru ?? '',
    en: map?.en ?? '',
});

export const toManifestMap = (value: LocalizedString): Record<string, string> => {
    const result: Record<string, string> = {};
    for (const locale of LOCALES) {
        if (value[locale]) result[locale] = value[locale];
    }
    return result;
};

interface Props {
    value: LocalizedString;
    onUpdate: (next: LocalizedString) => void;
    disabled?: boolean;
    placeholders?: Partial<Record<Locale, string>>;
}

export const LocalizedTextInputs: FC<Props> = ({ value, onUpdate, disabled, placeholders }) => (
    <>
        {LOCALES.map((locale) => (
            <div key={locale} className={styles.localizedInput}>
                <span className={styles.localeBadge}>{locale}</span>
                <TextInput
                    value={value[locale]}
                    onUpdate={(v) => onUpdate({ ...value, [locale]: v })}
                    disabled={disabled}
                    size="xl"
                    placeholder={placeholders?.[locale]}
                />
            </div>
        ))}
    </>
);
